import System from '../../componentes/sistema'
import { useState } from 'react'
import useGetUsers from './hooks/useGetUsers'
import ModalUserEdit from './components/modalUseredit'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Fab, IconButton } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'

import ModalUserCreate from './components/modalUserCreate'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#b80b1d',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}))

const fabStyle = {
    position: 'absolute',
    bottom: 16,
    right: 16,
}

const Usuarios = () => {
    const { usuarios } = useGetUsers()
    const [OpenModalCreate, setOpenModalCreate] = useState(false)
    const [OpenModalEdit, setOpenModalEdit] = useState(false)
    const [idDoc, setidDoc] = useState('')
    const [idRealation, setIdRelation] = useState('')

    const viewModalEditarUsuario = ({ idDoc, idRealtion }) => {
        setidDoc(idDoc)
        setIdRelation(idRealtion)
        setOpenModalEdit(true)
    }
    const handleCloseCreate = () => setOpenModalCreate(false)
    const handleCloseEdit = () => setOpenModalEdit(false)

    return (
        <>
            <ModalUserEdit openModal={OpenModalEdit} onClose={handleCloseEdit} idDoc={idDoc} idRealation={idRealation} />
            <ModalUserCreate openModal={OpenModalCreate} onClose={handleCloseCreate} />
            <Fab sx={fabStyle} aria-label="add" color='secondary' onClick={() => { setOpenModalCreate(true) }}>
                <AddIcon />
            </Fab>
            <System>
                {usuarios.length > 0 &&
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Email</StyledTableCell>
                                    <StyledTableCell>Rol</StyledTableCell>
                                    <StyledTableCell>Estado</StyledTableCell>
                                    <StyledTableCell>Acciones</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {usuarios.map((user) => (
                                    <StyledTableRow key={user.idDoc}>
                                        <StyledTableCell component="th" scope="row">
                                            {user.name}
                                        </StyledTableCell>
                                        <StyledTableCell>{user.email}</StyledTableCell>
                                        <StyledTableCell>{user.rol.label}</StyledTableCell>
                                        <StyledTableCell>{user.userStatus.label}</StyledTableCell>
                                        <StyledTableCell>
                                            <IconButton aria-label="action" onClick={() => { viewModalEditarUsuario({ idDoc: user.idDoc, idRealtion: user.idRelation }) }}>
                                                <EditIcon />
                                            </IconButton>
                                        </StyledTableCell>

                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>}

            </System>
        </>
    )
}

export default Usuarios